<template>
  <nav class="menu" v-click-outside="onClickOutside">
<!--    <div class="menu__contract-container" v-if="activeContract && contracts.length" @click="showContracts = !showContracts">-->
<!--      <div class="menu__contract-container-left">-->
<!--        <div class="menu__contract-name text&#45;&#45;bold text&#45;&#45;small mb-05 ">{{activeContract.partnerEntity.name ? activeContract.partnerEntity.name : '——'}}</div>-->
<!--        <div class="menu__contract-tax text&#45;&#45;small text-color-black text&#45;&#45;medium"><span class="text-color-grey">{{$t('components.Profile.formFields.INN')}}</span>: {{activeContract.partnerEntity.inn}}, <span class="text-color-space">{{$t('components.Menu.currency')}}</span>: {{currencySymbol(activeContract.currency)}}</div>-->
<!--      </div>-->
<!--      <div class="menu__contract-container-right"><i class="menu__contract-icon icon-show animate-smooth" :class="showContracts ? 'rotate-180' : ''"></i></div>-->
<!--    </div>-->

    <transition name="fade">
      <div class="menu__container pt-2" v-if="!showContracts">
        <div v-for="(item, index) of routes" class="menu__item" :key="index">
          <router-link exact-active-class="menu__item-link--active" :to="{ name: item.name }" class="menu__item-link text-color-black d-flex align-center text--small text--medium" @click.native="hideSidebars()">
            <div class="menu__item-icon heading-3 mr-2" :class="`${item.icon} ${item.iconClass}`"></div>
            <div>{{ item.label }}</div>
          </router-link>
        </div>
      </div>

      <div class="menu__container menu__container--contract-selector" v-else>
        <div v-for="(item, index) of contracts" :key="index" class="py-2 menu__contract-list-item" @click="setCurrContractId(item)">
          <div class="menu__contract-name text--bold text--small text-color-black mb-05">{{item.partnerEntity.name ? item.partnerEntity.name : '——'}}</div>
          <div class="menu__contract-tax text--small text-color-black text--medium"><span class="text-color-grey">{{$t('components.Profile.formFields.INN')}}</span>: {{item.partnerEntity.inn}}, <span class="text-color-space">{{$t('components.Menu.currency')}}</span>: {{currencySymbol(item.currency)}}</div>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import toSimpleDate from '@/mixins/toSimpleDate'
import currencySymbol from '@/mixins/currencySymbol'
import currContractId from '@/mixins/currContractId'
import hasActiveContracts from '@/mixins/hasActiveContracts'
import sidebars from '@/mixins/sidebars'
import profile from '@/mixins/profile'
import { ShowOrders, ShowSettlements, ShowBills, ShowRegisteredUsers, ShowPromoMaterials } from '@/mixins/displayRules'

import ClickOutside from '@/directives/clickOutside'

import { ManagerGQL } from '@/graphql/queries'

export default {
  mixins: [
    toSimpleDate,
    currencySymbol,
    currContractId,
    hasActiveContracts,
    sidebars,
    profile,

    ShowSettlements,
    ShowOrders,
    ShowBills,
    ShowRegisteredUsers,
    ShowPromoMaterials
  ],

  directives: {
    ClickOutside
  },

  data () {
    return {
      showContracts: false
    }
  },

  apollo: {
    contractList: {
      query: ManagerGQL,
      update: data => data.merchant.manager.partnerContractList,
      skip () { return !this.hasActiveContracts }
    }
  },

  methods: {
    setCurrContractId (item) {
      this.setContract(item.id)
      this.showContracts = false
    },

    onClickOutside () {
      if (this.showContracts) {
        this.showContracts = false
      }
    }
  },

  computed: {
    contracts () {
      if (!this.contractList) {
        return []
      }

      return this.contractList
    },

    activeContract () {
      return this.contracts.find(i => parseInt(i.id) === parseInt(this.currContractId))
    },

    routes () {
      const routeList = [
        {
          icon: 'icon-dashboard',
          label: this.$t('components.Menu.Dashboard'),
          name: 'dashboard',
          iconClass: ''
        },
        // {
        //   icon: 'icon-logo_swpl',
        //   label: 'SWITPLANET',
        //   name: 'switplanet',
        //   iconClass: 'menu__item-icon--green'
        // },
        {
          icon: 'icon-dollar',
          label: this.$t('components.Menu.goldshop'),
          name: 'goldshop',
          iconClass: ''
        },
        // {
        //   icon: 'icon-qr_code',
        //   label: 'Ваш QR код и QR чек',
        //   name: 'qr-generator-check',
        //   iconClass: ''
        // },
        {
          icon: 'icon-list',
          label: this.$t('components.Menu.Orders'),
          name: 'orders',
          iconClass: '',
          show: this.ShowOrders
        },
        {
          icon: 'icon-receipt',
          label: this.$t('components.Menu.bills'),
          name: 'bills',
          iconClass: '',
          show: this.ShowBills
        },
        {
          icon: 'icon-wallet',
          label: this.$t('components.Menu.settlements'),
          name: 'settlements',
          iconClass: '',
          show: this.ShowSettlements
        },
        {
          icon: 'icon-invoice',
          label: this.$t('components.Menu.documents'),
          name: 'documents',
          iconClass: ''
        },
        {
          icon: 'icon-promo_mat',
          label: this.$t('components.Menu.promoMaterials'),
          name: 'promo-materials',
          iconClass: '',
          show: !this.reqCountry.MEXICO || (this.reqCountry.MEXICO && this.ShowPromoMaterials)
        },
        {
          icon: 'icon-settings',
          label: this.$t('views.Dashboard.Documentation.menuName'),
          name: 'api',
          iconClass: ''
        },
        {
          icon: 'icon-users',
          label: this.$t('views.Referrals.title'),
          name: 'referrals',
          iconClass: '',
          show: this.ShowRegisteredUsers
        }
        // {
        //   icon: 'icon-statistics',
        //   label: 'Статистика',
        //   name: 'shop-analytics',
        //   iconClass: ''
        // }
        // {
        //   icon: 'icon-info',
        //   label: 'Инструкция',
        //   name: 'instructions',
        //   iconClass: ''
        // }
      ]

      return routeList.filter(r => r.show || typeof r.show === 'undefined')
    }
  }
}
</script>

<style lang="scss">
.menu {
  &__item-icon:before {
    color: $color-space;
    font-weight: normal;

    &:hover, &:active {
      color: $color-purple-light;
    }
  }

  &__contract-icon {

  }

  &__item-icon--green:before {
    color: $color-green;

    //noinspection CssInvalidPropertyValue
    @supports (background-clip: text) {
      background-image: $gradient-green-horizontal;
      color: transparent;
      background-clip: text;
    }
  }

  &__contract-container {
    background-color: $color-white;
    padding: 2rem $default-spacing-mobile;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom: 1.5px solid $color-space-lighten;

    &-left {
    }

    &-right {
      flex-basis: 2rem;
      margin-left: auto;

      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__container {
    padding-top: 1rem;
    overflow-y: auto;

    & > * {
      padding: .5rem $default-spacing-mobile;
      color: $color-space;

      @include respond(tab-port) {
        padding-left: $default-spacing;
        padding-right: $default-spacing;
      }

      &:hover, &:active {
        color: $color-purple-light;

        .menu__item-icon:before {
          color: $color-purple-light;
        }
      }
    }

    &--contract-selector {

    }
  }

  &__item-link {
    &--active, &--active:link {
      color: lighten($color-primary, 10%)!important;

      & > .menu__item-icon:before {
        color: lighten($color-primary, 10%)!important;
      }
    }
  }

  &__contract-list-item {
    cursor: pointer;

    @media(hover: hover) and (pointer: fine) {
      &:hover {
        background-color: rgba($color-black, .08);
      }
    }
  }

  &__contract-icon {
    color: $color-space;
    border: 1.5px solid $color-space;
    border-radius: 50%;
    padding: .3rem;
  }
}
</style>
